import { DataLayer } from "@sazka/utils/data-layer";

export namespace NgCasinoAnalytics {
    // DL3.60 in games analytics
    export const pushDepositClick = (gameCode: string) => {
        DataLayer.push({
            event: "action.deposit.game",
            action: {
                deposit: {
                    label: gameCode,
                },
            },
        });
    };
}
